import State from "@/helpers/pattern/state";
import { SubStatus } from "@/models/operativos/substatus";
import { modelIsModified } from "@/helpers/vue-mc";
import subStatusAPI from "@/services/operativos/substatus";
import CombosAPI from "@/services/catalogos";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { clearSwal } from "@/constants/sweet-alerts";
import { scrollToForm } from "@/helpers/form-scroll-to";
import { setSelectsInactiveDataMultipleJson, getJson, setJson } from "@/helpers/form-common";

/**
 * State Pattern for substatus form
 */
export default class SubStatusState extends State {
  /**
   * General Methods
   */
  base() {
    return {
      clear({ $setState }) {
        $setState("initial");
      }
      , async askForClear({ $data }) {
        try {
          if ((await $data.$swal(clearSwal)).value) this.clear();
        } catch (error) {
          console.error(error);
        }
      }
      , resetModel({ $data }) {
        this.clearTipoPEE();
        $data.substatus = new SubStatus();
      }
      , async setDefaults({ $data }) {
        let attributes = {};

        await this.loadSelectsData({ $data });

        if ($data.view.elem.select.tipo.filteredList.length > 0) {
          let visita = $data.view.elem.select.tipo.filteredList.filter((value) => value.name == "VISITA");
          let popentry = $data.view.elem.select.popentry.filteredList;
          let popexit = $data.view.elem.select.popexit.filteredList.map(function (el) {
            return el.name;
          });

          popentry.forEach((element) => {
            element.popexit = popexit;
          });

          visita.forEach((element, index) => {
            element.popentry = popentry;
            element.direccion = element.localizacion;
            element.provincia = element.localizacion;
            element.localidad = element.localizacion;
            element.codigopostal = element.localizacion;
            element.telefono = element.contacto;
            element.email = element.contacto;
            element.whatsapp = element.contacto;
            element.iniciativa = [];
            visita[index] = JSON.stringify(element);
          });

          attributes.tipo = visita;
        }

        $data.substatus = new SubStatus(attributes, null, {});

        this.setTipoPEE({ $data });
      }
      , resetValidators({ $data }) {
        $data.$v.$reset();
      }
      , isDisableButtonSubmit({ $data }) {
        return $data.hasErrors($data.$v.substatus) || $data.view.action.submit.busy || !modelIsModified($data.substatus);
      }
      , async loadSelectsData({ $data }) {
        const { data: { results: { combo: accionList } } } = await CombosAPI.get({ option: "accion" });
        $data.view.elem.select.accion.filteredList = accionList ? accionList.filter((value) => value.status) : [];
        $data.view.elem.select.accion.completeList = accionList || [];

        const { data: { results: { combo: statusprecontactoList } } } = await CombosAPI.get({ option: "statusprecontacto" });
        $data.view.elem.select.statusprecontacto.filteredList = statusprecontactoList ? statusprecontactoList.filter((value) => value.status) : [];
        $data.view.elem.select.statusprecontacto.completeList = statusprecontactoList || [];

        const { data: { results: { combo: tipoList } } } = await CombosAPI.get({ option: "tipo" });
        $data.view.elem.select.tipo.filteredList = tipoList ? tipoList.filter((value) => value.status && value.canales.includes("DEVOLUCIONES")) : [];
        $data.view.elem.select.tipo.completeList = tipoList || [];

        const { data: { results: { combo: postestList } } } = await CombosAPI.get({ option: "postest" });
        $data.view.elem.select.postest.filteredList = postestList ? postestList.filter((value) => value.status) : [];
        $data.view.elem.select.postest.completeList = postestList || [];

        const { data: { results: { combo: canalaceptacionList } } } = await CombosAPI.get({ option: "canalaceptacion" });
        $data.view.elem.select.canalaceptacion.filteredList = canalaceptacionList ? canalaceptacionList.filter((value) => value.status) : [];
        $data.view.elem.select.canalaceptacion.completeList = canalaceptacionList || [];

        const { data: { results: { combo: iniciativaList } } } = await CombosAPI.get({ option: "iniciativa" });
        $data.view.elem.select.iniciativa.filteredList = iniciativaList ? iniciativaList.filter((value) => value.status) : [];
        $data.view.elem.select.iniciativa.completeList = iniciativaList || [];

        const { data: { results: { combo: popentryList } } } = await CombosAPI.get({ option: "popentry" });
        $data.view.elem.select.popentry.filteredList = popentryList ? popentryList.filter((value) => value.status) : [];
        $data.view.elem.select.popentry.completeList = popentryList || [];

        const { data: { results: { combo: popexitList } } } = await CombosAPI.get({ option: "popexit" });
        $data.view.elem.select.popexit.filteredList = popexitList ? popexitList.filter((value) => value.status) : [];
        $data.view.elem.select.popexit.filteredListAlt = popexitList ? popexitList.filter((value) => value.status && value.name != "NO") : [];
        $data.view.elem.select.popexit.completeList = popexitList || [];
      }
      , setTipoPEE({ $data }) {
        this.clearTipoPEE();
        if ($data.substatus.tipo) {
          $data.substatus.tipo.forEach((tipo) => {
            tipo = JSON.parse(tipo);
            $data.tipomodel[tipo.code] = true;
            if (tipo.popentry) {
              tipo.popentry.forEach((popentry) => {
                $data.popentrymodel[tipo.code + "_" + popentry.code] = true;
                $data.popexitmodel[tipo.code + "_" + popentry.code] = popentry.popexit;
              });
            }
            this.setLocalization(tipo);
            this.setContacto(tipo);
            this.setAdicional(tipo);
          });
        }
      }
      , setLocalization({ $data }, tipo) {
        $data.direccionmodel[tipo.code] = tipo.direccion == null ? false : tipo.direccion;
        $data.provinciamodel[tipo.code] = tipo.provincia == null ? false : tipo.provincia;
        $data.localidadmodel[tipo.code] = tipo.localidad == null ? false : tipo.localidad;
        $data.codigopostalmodel[tipo.code] = tipo.codigopostal == null ? false : tipo.codigopostal;
      }
      , setContacto({ $data }, tipo) {
        $data.telefonomodel[tipo.code] = tipo.telefono == null ? false : tipo.telefono;
        $data.emailmodel[tipo.code] = tipo.email == null ? false : tipo.email;
        $data.whatsappmodel[tipo.code] = tipo.whatsapp == null ? false : tipo.whatsapp;
      }
      , setAdicional({ $data }, tipo) {
        $data.iniciativamodel[tipo.code] = tipo.adicional == null ? null : tipo.iniciativa;
      }
      , clearTipoPEE({ $data }) {
        $data.tipomodel = {};
        $data.popentrymodel = {};
        $data.popexitmodel = {};
        $data.direccionmodel = {};
        $data.provinciamodel = {};
        $data.localidadmodel = {};
        $data.telefonomodel = {};
        $data.emailmodel = {};
        $data.whatsappmodel = {};
        $data.iniciativamodel = {};
      }
    };
  }

  /**
   * States and their methods
   */
  states() {
    return {
      initial: {
        $constructor: function () {
          // Reset Models and validators
          this.resetModel();
          this.setDefaults();
          this.resetValidators();
        }
        , async submit({ $data }, {
          code, vacio, descripcion, accion, statusprecontacto, postest, canalaceptacion, tipo, clonable, payfac, gaps, status
        }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              scrollToForm($data);
              return false;
            }

            $data.view.action.submit.busy = true;

            const response = await subStatusAPI.save({
              clave: null
              , code
              , vacio
              , descripcion: vacio ? "VACIO " + descripcion : descripcion
              , accion: setJson(accion)
              , statusprecontacto: setJson(statusprecontacto)
              , postest: setJson(postest)
              , canalaceptacion: setJson(canalaceptacion)
              , tipo: setJson(tipo)
              , clonable
              , payfac: gaps ? false : payfac
              , gaps: payfac ? false : gaps
              , status
            });

            $data.view.action.submit.busy = false;
            this.resetModel();
            this.resetValidators();
            $data.$refs.subStatusTable.refreshData();
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
      , editing: {
        $constructor: function ({ $data }, {
          clave, code, vacio, descripcion, accion, statusprecontacto, postest, canalaceptacion, tipo, clonable, payfac, gaps, status
        }) {
          // Set options to combos if not are active
          $data.view.elem.select.accion.filteredList = setSelectsInactiveDataMultipleJson(accion, $data.view.elem.select.accion.completeList);
          $data.view.elem.select.statusprecontacto.filteredList = setSelectsInactiveDataMultipleJson(statusprecontacto, $data.view.elem.select.statusprecontacto.completeList);
          $data.view.elem.select.postest.filteredList = setSelectsInactiveDataMultipleJson(accion, $data.view.elem.select.postest.completeList);
          $data.view.elem.select.canalaceptacion.filteredList = setSelectsInactiveDataMultipleJson(canalaceptacion, $data.view.elem.select.canalaceptacion.completeList);
          $data.view.elem.select.tipo.filteredList = $data.setSelectsInactiveDataTipo(tipo, $data.view.elem.select.tipo.completeList);

          $data.substatus = new SubStatus({
            clave
            , code
            , vacio
            , descripcion: vacio ? descripcion.replace("VACIO ", "") : descripcion
            , accion: getJson(accion)
            , statusprecontacto: getJson(statusprecontacto)
            , postest: getJson(postest)
            , canalaceptacion: getJson(canalaceptacion)
            , tipo: getJson(tipo)
            , clonable
            , payfac: gaps ? false : payfac
            , gaps: payfac ? false : gaps
            , status
          });

          this.setTipoPEE();
          this.resetValidators();
          scrollToForm($data);
          $data.view.action.submit.busy = false;
        }
        , async submit({ $data }, {
          clave, code, vacio, descripcion, accion, statusprecontacto, postest, canalaceptacion, tipo, clonable, payfac, gaps, status
        }, insert) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              scrollToForm($data);
              return false;
            }

            if (!modelIsModified($data.substatus)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "info", "VL0000", $data.$t("errors.nochanges"));
              return false;
            }

            $data.view.action.submit.busy = true;

            let data = {
              clave: insert ? null : clave
              , code: insert ? null : code
              , vacio
              , descripcion: vacio ? "VACIO " + descripcion : descripcion
              , accion: setJson(accion)
              , statusprecontacto: setJson(statusprecontacto)
              , postest: setJson(postest)
              , canalaceptacion: setJson(canalaceptacion)
              , tipo: setJson(tipo)
              , clonable
              , payfac: gaps ? false : payfac
              , gaps: payfac ? false : gaps
              , status
            };

            const response = insert ? await subStatusAPI.save(data) : await subStatusAPI.update(data);

            this.resetModel();
            this.resetValidators();

            $data.$refs.subStatusTable.refreshData();
            $data.view.action.submit.busy = false;

            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/views/operativos/substatus/substatus-state.js